module.exports = __webpack_public_path__ + "img/tv-box.612b3df7.png";